import { Language } from "@src/reducers/your-reducer";
import { ISO3LanguageCode } from "@src/types/user-management";

export const toISO3 = (lang: Language): ISO3LanguageCode => {
  switch (lang) {
    case "en":
      return "eng";
    case "de":
      return "deu";
    case "zh":
      return "zho";
    case "it":
      return "ita";
    case "es":
      return "spa";
    case "pt":
      return "por";
    case "nl":
      return "nld";
    case "tr":
      return "tur";
    default:
      return "eng";
  }
};
